import React from 'react'

import SurveyLanguageDropdown from '.'
import { Loader } from 'shared/components/Loader'

/**
 * @param {object} props
 * @param {boolean} props.shouldDisabledLanguageDropdown
 * @param {number} props.currentSurveyLangauge
 * @param {number} props.languageId
 * @param {function} props.setLanguage
 * @param {object} props.surveyLanguages
 */
export default function SurveyLanguageDropdownContainer({
  shouldDisabledLanguageDropdown,
  currentSurveyLangauge,
  setLanguage,
  surveyLanguages,
  languageId,
}) {
  function sortLanguage(a, b) {
    return a.name - b.name
  }

  function toDropdownOptionFormat(languageOptions) {
    languageOptions.sort(sortLanguage)

    return languageOptions.map((option) => ({
      value: option.id,
      text: option.name,
      key: option.name,
    }))
  }

  function handleOnLanguageChange(_, { value }) {
    setLanguage(value)
  }

  if (!surveyLanguages) {
    return <Loader />
  }

  const languageOptions = toDropdownOptionFormat(surveyLanguages.results)
  const defaultLanguage = languageOptions.find((option) => option.value === currentSurveyLangauge)

  return (
    <SurveyLanguageDropdown
      disabled={shouldDisabledLanguageDropdown}
      value={languageId || defaultLanguage.value}
      languageOptions={languageOptions}
      handleOnLanguageChange={handleOnLanguageChange}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SurveyLanguageDropdown/container.js